var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHeader1ShapeABlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Asset 4"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2-2",
    opacity: 0.04
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46",
    d: "M230.12 718.25a2028.13 2028.13 0 01-220.56-10.7L1 706.7V0h1920v401.73l-14.14-5.05c-225.62-80.68-459.3-83.29-678.86 15.89-100.36 45.33-195.07 102.28-294.49 149.64-223.3 106.36-460.9 154.29-703.39 156.04z",
    fill: "#e4e8f1"
  }))))));
}

export default "data:image/svg+xml;base64,PHN2ZyBpZD0iTGF5ZXJfMSIgZGF0YS1uYW1lPSJMYXllciAxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxOTIwIDEwODAiPjxkZWZzPjxzdHlsZT4uY2xzLTF7b3BhY2l0eTowLjA0O30uY2xzLTJ7ZmlsbDojZTRlOGYxO308L3N0eWxlPjwvZGVmcz48ZyBpZD0iQXNzZXRfNCIgZGF0YS1uYW1lPSJBc3NldCA0IiBjbGFzcz0iY2xzLTEiPjxnIGlkPSJMYXllcl8yLTIiIGRhdGEtbmFtZT0iTGF5ZXIgMi0yIj48ZyBpZD0iTGF5ZXJfMS0yIiBkYXRhLW5hbWU9IkxheWVyIDEtMiI+PHBhdGggaWQ9IlBhdGhfNDYiIGRhdGEtbmFtZT0iUGF0aCA0NiIgY2xhc3M9ImNscy0yIiBkPSJNMjMwLjEyLDcxOC4yNUEyMDI4LjEzLDIwMjguMTMsMCwwLDEsOS41Niw3MDcuNTVMMSw3MDYuN1YwSDE5MjFWNDAxLjczbC0xNC4xNC01LjA1QzE2ODEuMjQsMzE2LDE0NDcuNTYsMzEzLjM5LDEyMjgsNDEyLjU3Yy0xMDAuMzYsNDUuMzMtMTk1LjA3LDEwMi4yOC0yOTQuNDksMTQ5LjY0QzcxMC4yMSw2NjguNTcsNDcyLjYxLDcxNi41LDIzMC4xMiw3MTguMjVaIi8+PC9nPjwvZz48L2c+PC9zdmc+";
export { SvgHeader1ShapeABlue as ReactComponent };